<template>
	<div class="modal" :class="{ 'is-active' : isActive }">
		<div class="modal-background"></div>
		<div class="modal-content box">
			<slot></slot>
		</div>
		<button class="modal-close is-large" aria-label="close" @click="close"></button>
	</div>
</template>

<script>

export default {
	name: 'about-modal',
	props: {
		isActive: Boolean
	},
	methods: {
		close() {
			this.$emit('update:showAboutModal', false)
		}
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/AboutModal.vue